import { convertEnergy2 } from "./convertEnergy";



export const geiCodes = {
  // Electricidad estándar
  electricity_standard_combined: "En1", // Electricidad estándar Combinada
  electricity_standard_domestic: "En2", // Electricidad estándar Doméstico
  electricity_standard_production: "En3", // Electricidad estándar Producción
 
  // Energías Renovables PPA
  renewable_energies_ppa_combined: "En5", // Energías Renovables (PPA) Combinada
  renewable_energies_ppa_domestic: "En6", // Energías Renovables (PPA) Doméstico
  renewable_energies_ppa_production: "En7", // Energías Renovables (PPA) Producción
 

  // Energías renovables producidas en el sitio
  renewable_energies_on_site_combined: "En9", // Energías renovables producidas en el sitio Combinada
  renewable_energies_on_site_domestic: "En10", // Energías renovables producidas en el sitio Doméstico
  renewable_energies_on_site_production: "En11", // Energías renovables producidas en el sitio Producción
  

  // Gas Natural
  natural_gas_combined: "En13", // Gas Natural Combinado (Doméstico / Producción)
  natural_gas_cogeneration: "En14", // Gas Natural - Cogeneración de Energía Eléctrica
  natural_gas_production_operations: "En15", // Gas Natural - Producción y Operaciones
  natural_gas_domestic: "En16", // Gas Natural - Doméstico
 

  // GLP
  glp_combined: "En18", // GLP (gas licuado de petróleo) Combinada
  glp_cogeneration: "En19", // GLP - Cogeneración de Energía Eléctrica
  glp_production_operations: "En20", // GLP - Producción y Operaciones
  glp_domestic: "En21", // GLP - Doméstico


  // Heavy Fuel Oil
  heavy_fuel_oil_total: "En23", // Heavy Fuel Oil (aceite combustible pesado)
  

  // Light Fuel Oil
  light_fuel_oil_total: "En25", // Light Fuel Oil (aceite combustible)
 

  // Carbón
  coal_total: "En27", // Carbón


  // Diesel
  diesel_combined: "En29", // Diesel combinado
  diesel_cogeneration: "En30", // Diesel - Cogeneración de Energía Eléctrica
  diesel_production_operations: "En31", // Diesel - Producción y Operaciones
  diesel_forklifts: "En32", // Diesel - Autoelevadores
 

  // Biodiesel
  biodiesel_combined: "En34", // Biodiesel combinado
  biodiesel_cogeneration: "En35", // Biodiesel - Cogeneración de Energía Eléctrica
  biodiesel_production_operations: "En36", // Biodiesel - Producción y Operaciones
  biodiesel_forklifts: "En37", // Biodiesel - Autoelevadores


  // Gasolina / Fuel Oil
  gasoline_combined: "En39", // Gasolina/Fuel Oil combinado
  gasoline_cogeneration: "En40", // Gasolina/Fuel Oil - Cogeneración de Energía Eléctrica
  gasoline_production_operations: "En41", // Gasolina/Fuel Oil - Producción y Operaciones
  gasoline_forklifts: "En42", // Gasolina/Fuel Oil - Autoelevadores


  // Biocombustible
  biofuel_combined: "En44", // Bio combustible combinado
  biofuel_cogeneration: "En45", // Bio combustible - Cogeneración de Energía Eléctrica
  biofuel_production_operations: "En46", // Bio combustible - Producción y Operaciones
  biofuel_forklifts: "En47", // Bio combustible - Autoelevadores
 

  // Biomasa
  biomass_total: "En49", // Biomasa
 

  // Vapor
  steam_total: "En51", // Vapor


  
  // --- Combustibles Vehículos ---

  // --- Gas Natural (Vehículos) ---
  natural_gas: "Veh1",                  // Consumo de Gas Natural en vehículos (MWh)

  // --- Gas Licuado de Petróleo (GLP) ---
  glp: "Veh3",                          // Consumo de GLP (MWh)
 

  // --- Diesel ---
  diesel: "Veh5",                       // Consumo de Diesel (MWh)


  // --- Biodiesel ---
  biodiesel: "Veh7",                    // Consumo de Diesel (MWh)


  // --- Gasolina ---
  gasoline: "Veh9",                     // Consumo de Gasolina (MWh)
 

  // --- Etanol ---
  ethanol: "Veh11",                     // Consumo de Etanol (MWh)


  // --- Electricidad para vehículos ---
  electricity_vehicles: "Veh13",        // Consumo de Electricidad en vehículos (MWh)
 
};

export const geiKPIsCodes = {
  // Indicadores de emisiones GEI
  alcance_1_kpis: "KPIgei1", // Alcance 1
  alcance_2_kpis: "KPIgei2", // Alcance 2
  alcance_3_kpis: "KPIgei3", // Alcance 3
};

const factoresEmision = {
  // 🔹 Alcance 2: electricidad comprada
  electricity_standard_combined: { factor: 0.43, unidad: "kwh", alcance: 2 },
  electricity_standard_domestic: { factor: 0.43, unidad: "kwh", alcance: 2 },
  electricity_standard_production: { factor: 0.43, unidad: "kwh", alcance: 2 },

  renewable_energies_ppa_combined: { factor: 0, unidad: "kwh", alcance: 2 },
  renewable_energies_ppa_domestic: { factor: 0, unidad: "kwh", alcance: 2 },
  renewable_energies_ppa_production: { factor: 0, unidad: "kwh", alcance: 2 },

  // 🔹 Alcance 1: combustibles fósiles consumidos directamente
  natural_gas_combined: { factor: 1.9, unidad: "m3", alcance: 1 },
  natural_gas_cogeneration: { factor: 1.9, unidad: "m3", alcance: 1 },
  natural_gas_production_operations: { factor: 1.9, unidad: "m3", alcance: 1 },
  natural_gas_domestic: { factor: 1.9, unidad: "m3", alcance: 1 },

  glp_combined: { factor: 1.5, unidad: "l", alcance: 1 },
  glp_cogeneration: { factor: 1.5, unidad: "l", alcance: 1 },
  glp_production_operations: { factor: 1.5, unidad: "l", alcance: 1 },
  glp_domestic: { factor: 1.5, unidad: "l", alcance: 1 },

  heavy_fuel_oil_total: { factor: 3.1, unidad: "l", alcance: 1 },
  light_fuel_oil_total: { factor: 2.5, unidad: "l", alcance: 1 },
  coal_total: { factor: 2.4, unidad: "kg", alcance: 1 },

  diesel_combined: { factor: 2.68, unidad: "l", alcance: 1 },
  diesel_cogeneration: { factor: 2.68, unidad: "l", alcance: 1 },
  diesel_production_operations: { factor: 2.68, unidad: "l", alcance: 1 },
  diesel_forklifts: { factor: 2.68, unidad: "l", alcance: 1 },

  biodiesel_combined: { factor: 2.68, unidad: "l", tipo: "%diesel", alcance: 1 },
  biodiesel_cogeneration: { factor: 2.68, unidad: "l", tipo: "%diesel", alcance: 1 },
  biodiesel_production_operations: { factor: 2.68, unidad: "l", tipo: "%diesel", alcance: 1 },
  biodiesel_forklifts: { factor: 2.68, unidad: "l", tipo: "%diesel", alcance: 1 },

  gasoline_combined: { factor: 3.10, unidad: "l", alcance: 1 },
  gasoline_cogeneration: { factor: 3.10, unidad: "l", alcance: 1 },
  gasoline_production_operations: { factor: 3.10, unidad: "l", alcance: 1 },
  gasoline_forklifts: { factor: 3.10, unidad: "l", alcance: 1 },

  biofuel_combined: { factor: 3.10, unidad: "l", tipo: "%combustible", alcance: 1 },
  biofuel_cogeneration: { factor: 3.10, unidad: "l", tipo: "%combustible", alcance: 1 },
  biofuel_production_operations: { factor: 3.10, unidad: "l", tipo: "%combustible", alcance: 1 },
  biofuel_forklifts: { factor: 3.10, unidad: "l", tipo: "%combustible", alcance: 1 },

  biomass_total: { factor: 0.10, unidad: "kg", alcance: 1 },
   steam_total: { factor: 0.20, unidad: "kg", alcance: 2 },

//   biomass_total: { factor: 0.10, unidad: "kWh", alcance: 1 },
// steam_total: { factor: 0.20, unidad: "kWh", alcance: 2 },


  // 🔹 Alcance 3: cadena de valor
  freight_transport: { factor: 2.8, unidad: "l", alcance: 3 },
  business_travel: { factor: 2.5, unidad: "l", alcance: 3 },
  purchased_goods: { factor: 1.8, unidad: "kg", alcance: 3 },

  // 🔹 Alcance 1: Combustibles para Vehículos (consumo directo)
  natural_gas: { factor: 1.9, unidad: "m3", alcance: 1 },  // Gas Natural - Vehículos
  glp: { factor: 1.5, unidad: "l", alcance: 1 },           // GLP - Vehículos
  diesel: { factor: 2.68, unidad: "l", alcance: 1 },       // Diesel - Vehículos
  biodiesel: { factor: 2.68, unidad: "l", tipo: "%diesel", alcance: 1 }, // Biodiesel - Vehículos
  gasoline: { factor: 2.31, unidad: "l", alcance: 1 },     // Gasolina - Vehículos
  ethanol: { factor: 1.5, unidad: "l", tipo: "%combustible", alcance: 1 }, // Etanol - Vehículos

  // 🔹 Alcance 1: Electricidad para Vehículos
  electricity_vehicles: { factor: 0.43, unidad: "kwh", alcance: 1 }, // Electricidad - Vehículos eléctricos
};



export function calculateEmissionsByType(value, fromUnit, fuelType, options = {}) {
  const registro = factoresEmision[fuelType];


  if (!registro) {
    console.warn(`Tipo de energía no encontrado: ${fuelType}`);
    return { emisiones: 0, alcance: null };
  }

  let { factor, unidad, tipo, alcance } = registro;

  // 🔹 Ajustes según porcentaje
  if (tipo === "%diesel" && options.porcentajeDiesel) {
    factor *= options.porcentajeDiesel / 100;
  }
  if (tipo === "%combustible" && options.porcentajeCombustible) {
    factor *= options.porcentajeCombustible / 100;
  }

  // 🔹 Conversión de unidad
  // Determinar si las unidades son de energía
  const isEnergyUnit = (u) => ["kwh", "mwh", "kj", "mj", "gj"].includes(u?.toLowerCase());
  const fromNorm = fromUnit?.toLowerCase();
  const toNorm = unidad?.toLowerCase();

  let valorConvertido;

  if (fromNorm === toNorm) {
    // Misma unidad, no convertir
    valorConvertido = value;
  } else if (isEnergyUnit(fromNorm) && isEnergyUnit(toNorm)) {
    // Ambas son unidades de energía, usar conversión con equivalencia
    valorConvertido = convertEnergy2(value, fromUnit, unidad, fuelType, true);
  } else if (isEnergyUnit(fromNorm) && !isEnergyUnit(toNorm)) {
    // Entrada en energía pero factor espera unidad física (kg, l, m3)
    // Usar valor directo - el factor debe ajustarse para kWh
    valorConvertido = value;
    console.warn(`⚠️ GEI [${fuelType}]: Datos en ${fromUnit}, factor espera ${unidad}. Usando valor directo.`);
  } else {
    // Intentar conversión normal
    valorConvertido = convertEnergy2(value, fromUnit, unidad, fuelType, false) || value;
  }

  // 🔹 Cálculo de emisiones (en kgCO₂e) 
  const emisiones = valorConvertido * factor;// /1000;

  return { emisiones, alcance }; // devolvemos ambos datos
}

// Función de fórmulas de indicadores para GEI (sigue el patrón de energyFormulasIndicators)
export const kgToTons = (kg) => kg / 1000;

export function geiFormulasIndicators(field, year, data, baseline, employees) {
  // Calcular emisiones por alcance
  let alcance1Total = 0;
  let alcance2Total = 0;
  let alcance3Total = 0;

  // Iterar sobre todos los campos de geiCodes
  Object.keys(geiCodes).forEach((key) => {
    const value = data[key]?.[year]?.total || 0;
    const unit = data[key]?.[year]?.unit || "kwh";

    if (value > 0) {
      const resultado = calculateEmissionsByType(value, unit, key);

      if (resultado.alcance === 1) {
        alcance1Total += resultado.emisiones;
      } else if (resultado.alcance === 2) {
        alcance2Total += resultado.emisiones;
      } else if (resultado.alcance === 3) {
        alcance3Total += resultado.emisiones;
      }
    }
  });

  // Retornar según el campo solicitado
  switch (field) {
    case "alcance_1_kpis":
      return {
        total: alcance1Total,
        unit: "kgCO₂e"
      };
    case "alcance_2_kpis":
      return {
        total: alcance2Total,
        unit: "kgCO₂e"
      };
    case "alcance_3_kpis":
      return {
        total: alcance3Total,
        unit: "kgCO₂e"
      };
    default:
      return {
        total: 0,
        unit: "kgCO₂e"
      };
  }
}



